import $ from "jquery";
import _ from "underscore";

const Base = {};

Base.goTo = function (url) {
  document.location.href = url;
};

Base.get_route = function (route, id, id2, id3) {
  // route should be a string or an array of strings
  var url = "";
  if (typeof route == "object") {
    var s = S.routes;
    _.each(route, function (r) {
      if (!s[r]) {
        console.log("Unable to find route for", route);
        return "";
      }
      s = s[r];
    });
    url = s;
  } else if (!S.routes[route]) {
    console.log("Unable to find route for", route);
    return "";
  } else {
    url = S.routes[route];
  }

  if (id) url = url.replace("99999", id);
  if (id2) url = url.replace("88888", id2);
  if (id3) url = url.replace("77777", id3);
  return url;
};

Base.get_template_route = function (route) {
  if (!S.routes.tmpls[route]) {
    console.log("Unable to find route for", route);
    return "";
  }
  var url = S.routes.tmpls[route];
  return url;
};

Base.get_template = function (tmpl_name, callback) {
  // Check if template is cached
  if (S.cachedTmpls[tmpl_name]) {
    callback(S.cachedTmpls[tmpl_name]);
    return;
  }
  // Check if the template is available in the dom
  if ($("[data-tmpl='" + tmpl_name + "']").size()) {
    var html = $("[data-tmpl='" + tmpl_name + "']")[0].outerHTML;
    S.cachedTmpls[tmpl_name] = html;
    callback(html);
    return;
  }
  if (!S.routes.tmpls[tmpl_name]) {
    console.log("Unable to find template named ", tmpl_name);
  }
  // Load template from server
  var url = S.routes.tmpls[tmpl_name];
  $.get(url, {}, function (data) {
    if (data.status) {
      if (data.data.loc) {
        S.loc = _.extend(S.loc || {}, data.data.loc);
      }

      S.cachedTmpls[tmpl_name] = data.data.html;
      callback(data.data.html);
    } else {
      S.cachedTmpls[tmpl_name] = data;
      callback(data);
    }
  });
};

Base.showModal = function (modalName) {
  if (localStorage.getItem("prevent-" + modalName)) return;
  Base.get_template(modalName, function (response) {
    $("body").append(response);
  });
};

Base.setupDatepicker = function ($elems, options) {
  options = options || {};
  if (
    !options.skipRange &&
    !options.yearRange &&
    !options.minDate &&
    !options.maxDate
  ) {
    options.yearRange = "-1:+1";
  }
  $elems
    .datepicker(
      _.extend(
        {
          showOtherMonths: true,
          selectOtherMonths: true,
          dateFormat: "yy-mm-dd",
          calendarWeeks: true,
          language: "sv",
        },
        options
      )
    )
    .prev(".input-group-btn")
    .on("click", (e) => {
      e && e.preventDefault();
      $(e.currentTarget).siblings("input").focus();
    });
  return $elems
    .on("focus", function () {
      $(this).closest(".input-group").addClass("focus");
    })
    .on("blur", function () {
      $(this).closest(".input-group").removeClass("focus");
    });
};

Base.setupFlexSelects = function ($elems, options = {}) {
  $elems.select2({
    formatResult: Common.formatFlexSelectRow,
    formatSelection: Common.formatFlexSelectRow,
    ...options,
  });
};

export default Base;
